import React, { useEffect } from "react";
import * as ReactDOM from "react-dom";
import { Modal } from "reactstrap";

import popupImg from "styles/common/img/common/img_modal_notice.png";

import "./AlertConfirmPopupNew.scss";

const ModalPopup = ({ giveAnswer, onMount, type, msg, buttonName, isTimeover, bigSize }) => {
    useEffect(() => {
        setTimeout(() => onMount && onMount(), 0);
    }, [onMount]);

    const formattedMsg = msg.replace(/\n/g, "<br>");

    /**
     * 본문(msg) 안에서 data-answer 를 단 요소를 누르면 그 값으로 응답하고 닫는다.
     * (예: <button data-answer="notice">[공지 바로가기]</button> → resolve("notice"))
     */
    const handleMsgClick = (event) => {
        const answerTarget = event.target.closest?.("[data-answer]");
        if (answerTarget) giveAnswer(answerTarget.dataset.answer);
    };

    return (
        // bigSize : 공지처럼 본문이 긴 확인창용 큰 버전
        <Modal className={`allNewModal ${bigSize ? "allNewModal--big" : ""}`.trim()} isOpen={true}>
            <button
                type="button"
                className="allNewModal__close"
                onClick={() => (isTimeover ? giveAnswer(true) : giveAnswer(false))}
            ></button>
            <div className="allNewModal__box">
                <div className="allNewModal__img">
                    <img src={popupImg} alt="" />
                </div>
                <div
                    className="allNewModal__txt"
                    onClick={handleMsgClick}
                    dangerouslySetInnerHTML={{ __html: formattedMsg }}
                />
                <div className="pop_btn2">
                    {type === "ALERT" ? (
                        <button type="button" className="new2btn newbtn__txt" onClick={() => giveAnswer(true)}>
                            {buttonName ? buttonName : "확인"}
                        </button>
                    ) : type === "CONFIRM" ? (
                        <>
                            <button type="button" className="newbtn newbtn__txt" onClick={() => giveAnswer(false)}>
                                취소
                            </button>
                            <button type="button" className="new2btn newbtn__txt" onClick={() => giveAnswer(true)}>
                                {buttonName ? buttonName : "확인"}
                            </button>
                        </>
                    ) : null}
                </div>
            </div>
        </Modal>
    );
};

function AlertConfirmPopup(props) {
    return new Promise((resolve) => {
        const giveAnswer = (answer) => {
            const modalRoot = document.getElementById("modal-root");
            resolve(answer);
            ReactDOM.unmountComponentAtNode(modalRoot);
        };

        const handleModalMount = () => {
            const modalElement = document.querySelector(".modal");
            if (modalElement?.parentNode) {
                const modalParentNode = modalElement.parentNode.parentNode;
                if (modalParentNode) {
                    modalParentNode.style.zIndex = "initial";
                }
            }
        };

        const modalRoot = document.getElementById("modal-root") || document.createElement("div");
        if (!modalRoot.id) {
            modalRoot.id = "modal-root";
            document.body.appendChild(modalRoot);
        }

        ReactDOM.render(<ModalPopup giveAnswer={giveAnswer} onMount={handleModalMount} {...props} />, modalRoot);
    });
}

export default AlertConfirmPopup;
